var _path, _path2, _path3, _path4, _path5, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGxSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "gx-sign",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6d6c6c",
    stroke: "#6d6c6c",
    strokeWidth: 12,
    d: "M50,1C22.938,1,1,22.938,1,50c0,27.063,21.938,49,49,49 c27.061,0,49-21.938,49-49C99,22.938,77.061,1,50,1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d054",
    stroke: "#6d6c6c",
    strokeWidth: 2,
    d: "M56.363,50l29.886-29.885C92.963,28.244,97,38.659,97,50 s-4.038,21.757-10.751,29.885L56.363,50z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d054",
    stroke: "#6d6c6c",
    strokeWidth: 2,
    d: "M79.885,13.75L50,43.636L20.116,13.75C28.244,7.038,38.659,3,50,3 S71.756,7.038,79.885,13.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d054",
    stroke: "#6d6c6c",
    strokeWidth: 2,
    d: "M13.75,20.115L43.636,50L13.751,79.885C7.038,71.757,3,61.341,3,50 S7.038,28.244,13.75,20.115z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d054",
    stroke: "#6d6c6c",
    strokeWidth: 2,
    d: "M20.115,86.249L50,56.364l29.885,29.885C71.757,92.962,61.341,97,50,97 S28.243,92.962,20.115,86.249z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6d6c6c",
    d: "M21.657,57.677l-5.155-7.257v7.257h-3.657V37.604h5.587c4.762,0,7.143,2.131,7.143,6.394 c0,0.951-0.154,1.884-0.461,2.801c-0.307,0.917-0.809,1.73-1.505,2.44c-0.696,0.71-1.586,1.2-2.671,1.469l5.184,6.969H21.657z  M18.028,48.605c0.815,0,1.514-0.194,2.095-0.583s1.02-0.907,1.318-1.555c0.297-0.648,0.446-1.356,0.446-2.124 c0-1.325-0.305-2.299-0.914-2.923c-0.61-0.624-1.621-0.936-3.031-0.936h-1.44v8.122L18.028,48.605L18.028,48.605z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6d6c6c",
    d: "M84.617,57.712l-4.993-7.03v7.03h-3.543V38.266h5.412c4.612,0,6.92,2.065,6.92,6.194 c0,0.921-0.149,1.826-0.447,2.713c-0.298,0.888-0.782,1.676-1.458,2.365c-0.674,0.688-1.537,1.162-2.587,1.423l5.021,6.751H84.617z  M81.104,48.924c0.789,0,1.467-0.188,2.028-0.564c0.563-0.377,0.988-0.879,1.276-1.507c0.287-0.628,0.433-1.313,0.433-2.058 c0-1.283-0.295-2.227-0.885-2.832c-0.593-0.604-1.57-0.906-2.938-0.906h-1.395v7.867H81.104z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGxSign);
export default __webpack_public_path__ + "static/media/gx-sign.a101c4cd.svg";
export { ForwardRef as ReactComponent };